<template>
  <!--Header Banner-->
  <section class="header-banner">
    <img src="@/assets/images/hero.png" />
  </section>
</template>

<script>
export default {};
</script>

<style>
</style>
